// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"62531937","143":"d7dd6b6b","255":"9396c72c","486":"dabd673a","499":"8cb96c14","530":"1fc275d6","562":"40e7f76b","638":"984925b3","645":"e37b913a","688":"c0c24f23","936":"82e56b9e"}[chunkId] + ".chunk.js";
};